import React, { useCallback } from 'react';
import { GraphicSize, ShoppingBag } from '@lux/graphics';
import { ButtonColor } from '@lux/buttons';
import { Text, Preset } from '@lux/text';
import { Translate } from '@pegasus/translation';
import { isMobile } from '../../../../lib/screenSize';
import { navigationItem } from '../../../../tokens/navigationItem';
import { CTAButton, Wrapper } from './styles';
export const EmptyCart = ({ onNavigationChange }) => {
    const handleNavigationChange = useCallback(() => {
        onNavigationChange(navigationItem.homepage);
    }, [onNavigationChange]);
    return (React.createElement(Wrapper, null,
        React.createElement(ShoppingBag, { size: GraphicSize.XXL }),
        React.createElement(Text, { preset: Preset.S, color: "inherit" },
            React.createElement(Translate, { message: "emptyCart" })),
        isMobile() && (React.createElement(CTAButton, { id: "navigate-to-homepage", color: ButtonColor.primary, href: "/event", onClick: handleNavigationChange, fullWidth: true },
            React.createElement(Translate, { message: "emptyCartCTA" })))));
};
//# sourceMappingURL=index.js.map